// Client-made jobs (receiver app, WhatsApp bot) stand apart from staff-made ones
export const getAuthorBadgeClass = (isCreatedByClient?: boolean): string =>
  isCreatedByClient ? "bg-brand-blue text-white" : "bg-brand-red text-white";
